// @flow
import algoliaSearch from 'utils/algoliaSearch';
import getSearchIndex from 'utils/search/getSearchIndex';
import getVolopsSearchIndex from 'utils/search/getVolopsSearchIndex';
import getSearchConfig from 'utils/search/getSearchConfig';
import { updateObject } from 'utils/functional';
import type { Dispatch, GetState } from '..';
import { setError } from './error';

export type Action = {
  type: 'LISTING_COUNTS_SET',
  counts: ?{ [string]: number }
};

const getVolopsListingCounts = () => {
  const searchConfig = getSearchConfig();
  const queryOptions = {
    index: getVolopsSearchIndex(),
    facets: '*',
    hitsPerPage: 0
  };
  return algoliaSearch(searchConfig, '', queryOptions, false).then(r => ({
    VOLOP: r.nbHits
  }));
};
const getMainIndexListingCounts = () => {
  const searchConfig = getSearchConfig();
  const index = getSearchIndex();
  const queryOptions = {
    index,
    facets: 'type',
    hitsPerPage: 0
  };
  return algoliaSearch(searchConfig, '', queryOptions, false).then(
    r => r.facets.type
  );
};

export const fetchListingCounts = ({
  indices
}: {
  indices: Array<'MAIN_SEARCH' | 'VOLOPS'>
}) => (dispatch: Dispatch, getState: GetState) => {
  if (getState().listingCounts) {
    return;
  }
  const typeToFetch: {
    ['MAIN_SEARCH' | 'VOLOPS']: () => Promise<{ results: Object }>
  } = {
    MAIN_SEARCH: getMainIndexListingCounts,
    VOLOPS: getVolopsListingCounts
  };
  Promise.all(indices.map(i => typeToFetch[i]).map(f => f()))
    .then(allResults => {
      // But for flow, Object.assign would work fine as the reducing function
      const collatedCounts = allResults.reduce(updateObject);
      dispatch({ type: 'LISTING_COUNTS_SET', counts: collatedCounts });
    })
    .catch(setError);
};
